export var FallbackCorvidModel = {
    componentType: 'Fallback',
    loadSDK: function () {
        return import('./Fallback.corvid' /* webpackChunkName: "Fallback.corvid" */);
    },
};
export default FallbackCorvidModel;
//# sourceMappingURL=entry.corvid.js.map